import spinner from '../../../icons/spinnerBlue.svg';

const Loader = () => (
  <div className='loader'>
    <img src={spinner} alt='' />
  </div>
);

export default Loader;
